import React from 'react';
import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import ToggleSwitch from '@/common/components/ToggleSwitch';

import { useEmployeeKpiSearchBox } from '../hooks/useEmployeeKpiSearchBox';
import { VIEW_TYPE_ENUM } from '../constants/employeeKpiReport.constants';
import { DEFAULT_KPI_THRESHOLDS } from '../config/kpiThresholds';

const SearchBoxContainer = styled.div`
	padding: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${Colors.darkBlue};
	border: 1px solid ${Colors.darkBlue};
	min-width: 50vw;
	gap: 30px;
	border-radius: 15px;
	margin-bottom: 30px;
`;

const FilterCol = styled.div``;

const DateInputGroup = styled.div``;

const ActionsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
`;

const EmployeeKpiReportSearchBox = ({ handleSearchCallback, setT }) => {
	const { state, options, actions } =
		useEmployeeKpiSearchBox(handleSearchCallback);

	const {
		viewType,
		dateRange,
		selectedQueue,
		selectedConsultants,
		selectedMonths,
		includeInactive,
	} = state;

	return (
		<SearchBoxContainer>
			<FilterCol>
				<SelectInput
					name='Mode'
					color={Colors.darkBlue}
					width={130}
					selectWidth={140}
					selected={viewType}
					setSelected={actions.setViewType}
					options={options.viewTypeOptions}
					required
				/>

				{viewType?.value === VIEW_TYPE_ENUM.DAILY && (
					<DateInputGroup>
						<Input
							type='date'
							name='Data OD'
							value={dateRange.from || ''}
							onChange={(e) =>
								actions.setDateRange((p) => ({ ...p, from: e.target.value }))
							}
							width={130}
							inputWidth={140}
							color={Colors.darkBlue}
							required
							requiredSign
						/>
						<Input
							type='date'
							name='Data DO'
							value={dateRange.to || ''}
							onChange={(e) =>
								actions.setDateRange((p) => ({ ...p, to: e.target.value }))
							}
							width={130}
							inputWidth={140}
							color={Colors.darkBlue}
							required
							requiredSign
						/>
					</DateInputGroup>
				)}

				{viewType?.value === VIEW_TYPE_ENUM.MONTHLY && (
					<SelectInput
						multiple={true}
						name='Month'
						options={options.monthOptions || []}
						selected={selectedMonths || []}
						setSelected={actions.setSelectedMonths}
						color={Colors.darkBlue}
						width={130}
						selectWidth={300}
						required
					/>
				)}
				<Input
					type='number'
					name='T Confirmed'
					value={DEFAULT_KPI_THRESHOLDS.CONFIRMED}
					onChange={(e) => setT((p) => ({ ...p, confirmed: e.target.value }))}
					width={130}
					inputWidth={60}
					color={Colors.darkBlue}
					required
					requiredSign
				/>
				<Input
					type='number'
					name='T Delivered'
					value={DEFAULT_KPI_THRESHOLDS.DELIVERED}
					onChange={(e) => setT((p) => ({ ...p, delivered: e.target.value }))}
					width={130}
					inputWidth={60}
					color={Colors.darkBlue}
					required
					requiredSign
				/>
			</FilterCol>

			<FilterCol>
				<SelectInput
					name='Queue'
					options={options.queueOptions || []}
					selected={selectedQueue}
					setSelected={actions.handleQueueChange}
					color={Colors.darkBlue}
					width={120}
					selectWidth={400}
				/>

				<SelectInput
					multiple={true}
					name='Consultant'
					options={options.userOptions || []}
					selected={selectedConsultants || []}
					setSelected={actions.setSelectedConsultants}
					color={Colors.darkBlue}
					width={120}
					selectWidth={400}
					required
				/>

				<ActionsWrapper>
					<ToggleSwitch
						text='Include Inactive'
						checked={!!includeInactive}
						onChange={(e) => actions.setIncludeInactive(e.target.checked)}
						width={140}
					/>
					<ActionButton text='Reset' onClick={actions.handleReset} />
					<ActionButton text='Search' onClick={actions.handleSearch} />
				</ActionsWrapper>
			</FilterCol>
		</SearchBoxContainer>
	);
};

export default EmployeeKpiReportSearchBox;
